import { render, staticRenderFns } from "./shopping-lists-table.vue?vue&type=template&id=0fc916f4&"
import script from "./shopping-lists-table.vue?vue&type=script&lang=js&"
export * from "./shopping-lists-table.vue?vue&type=script&lang=js&"
import style0 from "./shopping-lists-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports